import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { ContainerForm } from '@/components/Form/ContainerForm'
import { updatecentreConfiguration } from '@/store/centreConfigurations/actions'
import { updateCentreAdmin } from '@/store/centres/actions'
import { yupResolver } from '@hookform/resolvers/yup'

import { formDefaultValues } from './formConfig'
import { FormContent } from './formContent'
import { formValidationSchema } from './formValidation'

import s from './styles.module.scss'

const FormUpdateAdmin = ({ formValues, onClose }) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (data) => {
    setIsLoading(true)

    let auxCentreConfiguration = { ...data?.centreConfiguration }

    try {
      if (formValues) {
        await dispatch(updateCentreAdmin(data))
        await dispatch(updatecentreConfiguration(auxCentreConfiguration))
      }
      onClose()
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <ContainerForm
        className={s.containerForm}
        onSubmit={(data) => handleSubmit(data)}
        defaultValues={{ ...formDefaultValues, ...formValues }}
        resolver={yupResolver(formValidationSchema)}
      >
        <FormContent isLoading={isLoading} onClose={onClose} />
      </ContainerForm>
    </div>
  )
}

export default FormUpdateAdmin
